import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import { CRATE_COUPON_SET, getCampaignCreateSuccessStepBar } from '../../../components/base/prompt/NextStepConfig';
import NextStepPrompt from '../../../components/base/prompt/NextStepPrompt';
import BaseForm from '../../../components/base/v2/BaseForm';
import { createCouponBreads } from '../../../config/CustomBreadConfig';
import { APIStatus, CampaignType, COUPON_TYPES } from '../../../config/CustomEnums';
import { PermissionCodes } from '../../../config/PermissionCodes';
import { removeCouponSessionStroage, saveCouponToSessionStorage } from '../../../models/CreateCouponModel';
import { createAction } from '../../../utils';
import { TAB_LIST_OF_COUPON_SETS } from './CouponList';
import CreateCouponStepOne from './CreateCouponStepOne';
import CreateCouponStepThree from './CreateCouponStepThree';
import CreateCouponStepTwo from './CreateCouponStepTwo';
import CreateCouponStepOneV2 from './CreateCouponStepOneV2';
import Loading from 'components/base/Loading';


function CreateCoupon({
  stepConfig,
  currentStep,
  formHasSubmitted,
  couponTemplate,
  hasUpdatedDefaultValues,
  createCouponTemplateStatus,
  generateCouponStatus,
  showEditSuccessPrompt,
  generateCouponInfo,
  couponStores,
  detailLoading,
}) {
  const location = useLocation();
  const params = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = params;

  const stepSet = [
    // <CreateCouponStepOne />,
    // <CreateCouponStepTwo />,
    // <CreateCouponStepThree />,
    <CreateCouponStepOneV2 />
  ];

  useEffect(() => {
    dispatch(createAction('language/getList')({ isSelectorLoad: true }));

    const newItem = location.state || {};
    console.log('newItem:', location);
    if (id) {
      dispatch(
        createAction('couponList/getCouponSet')({
          couponSetPK: params.id,
          ...newItem,
        }),
      );
    } else {
      dispatch(
        createAction('createCoupon/loadCouponFromCookie')({ ...newItem }),
      );
      dispatch(createAction('brand/getAllBrands')({}));
      dispatch(createAction('mall/getPagedMallList')({}));
      dispatch(
        createAction('storeCategoryList/getStoreCategoryList')({
          pageSize: 100,
        }),
      );
    }

    return () => {
      dispatch({ type: 'createCoupon/clearState' });
      dispatch({ type: 'storeModel/clearData' });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id]);


  useEffect(() => {
    if (!id && couponTemplate.couponStores) {
      dispatch(
        createAction('storeModel/updateState')({
          couponStores: couponTemplate.couponStores,
        }),
      );
    }
  }, [id, couponTemplate]);

  const goToCouponList = () => {
    history.push({ pathname: '/coupons', hash: TAB_LIST_OF_COUPON_SETS });
  };

  const getNextStepConfig = () => {
    return {
      title: 'Successfully Create!',
      description: 'The coupon set is successfully created.\n Let’s create a coupon campaign based on these coupon or you can generate a single coupon to a customer.',
      type: CRATE_COUPON_SET,
      stepNames: getCampaignCreateSuccessStepBar(
        CampaignType.couponsCampaign,
        true,
      ),
      buttons: [
        {
          text: 'Create Coupon campaign',
          action: () =>
            history.push({
              pathname: '/campaigns/create',
              search: `type=${CampaignType.couponsCampaign}&id=${generateCouponInfo.couponTemplatePk}`,
            }),
          requires: PermissionCodes.addCampaign,
        },
        {
          text: 'Maybe Later',
          action: goToCouponList,
        },
      ],
    };
  };

  if (detailLoading === APIStatus.calling) {
    return <Loading />
  }

  return (
    <>
      <BaseForm
        defaultValues={couponTemplate}
        hasUpdatedDefaultValues={hasUpdatedDefaultValues}
        formHasSubmitted={formHasSubmitted}
        tempSave={(save, getValues) => {
          if (save) {
            saveCouponToSessionStorage({
              ...getValues(),
              couponStores,
            });
          } else {
            removeCouponSessionStroage();
          }
        }}
        nextStepConfig={{
          title: getNextStepConfig().title,
          description: getNextStepConfig().description,
          steps: {
            stepNames: getNextStepConfig().stepNames,
            current: getNextStepConfig().type,
          },
          buttons: getNextStepConfig().buttons,
          onHide: () => { },
        }}
        showFinishPop={
          !generateCouponInfo.showGenerateCouponPop &&
          (generateCouponStatus === APIStatus.success ||
            createCouponTemplateStatus === APIStatus.success)
        }
        continueCreateConfig={{
          onConfirm: () => {
            history.push(history.location.state?.from);
          },
          onCancel: goToCouponList,
          onClose: goToCouponList,
        }}
        // sessionDataKey={sessionDataKey}
        content={stepSet}
        currentStep={currentStep}
        breadcrumb={
          <CustomBreadcrumb breadcrumbs={createCouponBreads(params?.id)} />
        }
        stepsConfig={[]}
        caution={{
          detail:
            'Coupon set stores the content and controls a list of couopn.After you create a coupon set, you can general a list of single coupons for your customers',
          title: 'Coupon Set',
        }}
      />
      <NextStepPrompt
        show={showEditSuccessPrompt}
        title="Successfully Saved!"
        description="Copuon is successfully saved."
        steps={null}
        buttons={[
          {
            text: 'Back to coupon listing page',
            action: goToCouponList,
            requires: PermissionCodes.viewCoupon,
          },
          {
            text: 'Continue edit',
            action: () => {
              dispatch({ type: 'createCoupon/hideEditorSuccessPrompt' });
            },
          },
        ]}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  stepConfig: state.createCoupon.stepConfig,
  currentStep: state.createCoupon.currentStep,
  formHasSubmitted: state.createCoupon.formHasSubmitted,
  couponTemplate: state.createCoupon.couponTemplate,
  hasUpdatedDefaultValues: state.createCoupon.hasUpdatedDefaultValues,
  createCouponTemplateStatus: state.createCoupon.createCouponTemplateStatus,
  generateCouponStatus: state.createCoupon.generateCouponStatus,
  showEditSuccessPrompt: state.createCoupon.showEditSuccessPrompt,
  generateCouponInfo: state.createCoupon.generateCoupon,
  couponStores: state.storeModel.couponStores,
  detailLoading: state.couponList.detailLoading,
});

export default connect(mapPropsToState)(CreateCoupon);